import { render } from "./CreateClients.vue?vue&type=template&id=c7c1d5da"
import script from "./CreateClients.vue?vue&type=script&lang=js"
export * from "./CreateClients.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__